import React, { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import api from "../lib/api";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    try {
      const r = await api.post("/subscribe", { email, name });
      setDone(true);
      setMsg(r.data.message || "Subscribed!");
      setEmail("");
      setName("");
    } catch (err) {
      setMsg(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="newsletter" id="updates">
      <div className="container">
        <div className="news-card">
          <div className="news-copy">
            <span className="news-icon"><Mail size={22} /></span>
            <div>
              <h2>Get load & dispatch updates</h2>
              <p>Sign up to get new loads, availability, and Flying Fleet Dispatch news straight to your inbox.</p>
            </div>
          </div>
          <form className="news-form" onSubmit={submit}>
            <input
              type="text"
              placeholder="Name (optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="news-name"
            />
            <div className="news-row">
              <input
                type="email"
                required
                placeholder="you@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit" className="btn btn-primary" disabled={busy}>
                {busy ? <Loader2 size={16} className="spin" /> : done ? <CheckCircle2 size={16} /> : null}
                {done ? "Subscribed" : "Sign Up"}
              </button>
            </div>
            {msg && <div className={`news-msg ${done ? "ok" : "err"}`}>{msg}</div>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
